










































































import { ComplementaryModel, VForm } from '@/app/shared/models';
import { refsService } from '@/app/shared/refs.service';
import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
@Component
export default class DialogComplementaryComponent extends Vue {
  @Prop(String) readonly type!: string;
  @Prop(Object) readonly complementary!: ComplementaryModel;
  @Ref() private form!: VForm;
  private newEditComplementary = { ...this.complementary };

  private dialog = false;
  private valueTab = '';

  private get refs() {
    return refsService;
  }
  private get rules() {
    return this.refs.static.rules;
  }
  private get contractModule() {
    return this.refs.modules.contract;
  }

  private async saveComplementary() {
    if (this.form && !this.form.validate()) {
      // Run after the next update cycle
      this.$nextTick(() => {
        const el = document.querySelector(
          '.v-messages.error--text:first-of-type'
        );
        if (el) {
          el.scrollIntoView();
        }
      });
      this.$toast(this.$t('toasts.incomplete_or_invalid_fields'));
      return;
    }

    this.newEditComplementary.Id
      ? await this.contractModule
          .updateComplementary({
            contractId: this.contractModule.contract.Id,
            complementaryId: this.newEditComplementary.Id,
            complementary: this.newEditComplementary,
            descReason: this.valueTab,
          })
          .then(async () => {
            this.successComplementary();
          })
          .catch((err) => {
            this.$toast.error('ERROR ? ', err);
            this.$toast.error(this.$t('toasts.change_complementary_error'));
          })
      : await this.contractModule
          .addComplementary({
            contractId: this.contractModule.contract.Id,
            complementary: this.newEditComplementary,
            descReason: this.valueTab,
          })
          .then(async () => {
            this.successComplementary();
          })
          .catch((err) => {
            this.$toast.error('ERROR ? ', err);
            this.$toast.error(this.$t('toasts.change_complementary_error'));
          });
  }

  public async successComplementary() {
    if (this.type == 'edit')
      this.$toast(this.$t('toasts.change_complementary_successfully'));
    else this.$toast(this.$t('toasts.added_complementary_successfully'));
    try {
      await this.contractModule
        .loadComplementaryByContractId(this.$route.params.id)
        .then(() => {
          this.valueTab = '';
          localStorage.removeItem('tabulacao');
          this.$bus.$emit('cleanValueTab');
        });
      this.dialog = false;
    } catch (err) {
      this.$toast.error('ERROR ? ', err);
      this.$toast.error(this.$t('toasts.change_complementary_error'));
    }
  }
}
